import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card-header border-0 pt-5" }
const _hoisted_2 = { class: "card-title align-items-start flex-column" }
const _hoisted_3 = { class: "card-label fw-bold fs-3 mb-1" }
const _hoisted_4 = { class: "card-body overlay-wrapper py-3" }
const _hoisted_5 = { class: "tab-content" }
const _hoisted_6 = {
  class: "tab-pane fade active show",
  id: "kt_table_widget_5_tab_1",
  role: "tabpanel"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "tab-pane fade",
  id: "kt_table_widget_5_tab_2",
  role: "tabpanel"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "table-responsive" }, [
    /*#__PURE__*/_createElementVNode("table", { class: "table table-row-dashed table-row-gray-200 align-middle gs-0 gy-4" }, [
      /*#__PURE__*/_createElementVNode("thead", null, [
        /*#__PURE__*/_createElementVNode("tr", { class: "border-0" }, [
          /*#__PURE__*/_createElementVNode("th", { class: "p-0 w-50px" }),
          /*#__PURE__*/_createElementVNode("th", { class: "p-0 min-w-150px" }),
          /*#__PURE__*/_createElementVNode("th", { class: "p-0 min-w-140px" }),
          /*#__PURE__*/_createElementVNode("th", { class: "p-0 min-w-110px" }),
          /*#__PURE__*/_createElementVNode("th", { class: "p-0 min-w-50px" })
        ])
      ]),
      /*#__PURE__*/_createElementVNode("tbody", null, [
        /*#__PURE__*/_createElementVNode("tr", null, [
          /*#__PURE__*/_createElementVNode("td", null, [
            /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-45px me-2" }, [
              /*#__PURE__*/_createElementVNode("span", { class: "symbol-label" }, [
                /*#__PURE__*/_createElementVNode("img", {
                  src: "/metronic8/demo8/assets/media/svg/brand-logos/plurk.svg",
                  class: "h-50 align-self-center",
                  alt: ""
                })
              ])
            ])
          ]),
          /*#__PURE__*/_createElementVNode("td", null, [
            /*#__PURE__*/_createElementVNode("a", {
              href: "#",
              class: "text-dark fw-bold text-hover-primary mb-1 fs-6"
            }, "Brad Simmons"),
            /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-semibold d-block" }, "Movie Creator")
          ]),
          /*#__PURE__*/_createElementVNode("td", { class: "text-end text-muted fw-bold" }, "React, HTML"),
          /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, [
            /*#__PURE__*/_createElementVNode("span", { class: "badge badge-light-success" }, "Approved")
          ]),
          /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, [
            /*#__PURE__*/_createElementVNode("a", {
              href: "#",
              class: "btn btn-sm btn-icon btn-bg-light btn-active-color-primary"
            }, [
              /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
                /*#__PURE__*/_createElementVNode("svg", {
                  width: "24",
                  height: "24",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  /*#__PURE__*/_createElementVNode("rect", {
                    opacity: "0.5",
                    x: "18",
                    y: "13",
                    width: "13",
                    height: "2",
                    rx: "1",
                    transform: "rotate(-180 18 13)",
                    fill: "currentColor"
                  }),
                  /*#__PURE__*/_createElementVNode("path", {
                    d: "M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z",
                    fill: "currentColor"
                  })
                ])
              ])
            ])
          ])
        ]),
        /*#__PURE__*/_createElementVNode("tr", null, [
          /*#__PURE__*/_createElementVNode("td", null, [
            /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-45px me-2" }, [
              /*#__PURE__*/_createElementVNode("span", { class: "symbol-label" }, [
                /*#__PURE__*/_createElementVNode("img", {
                  src: "/metronic8/demo8/assets/media/svg/brand-logos/telegram.svg",
                  class: "h-50 align-self-center",
                  alt: ""
                })
              ])
            ])
          ]),
          /*#__PURE__*/_createElementVNode("td", null, [
            /*#__PURE__*/_createElementVNode("a", {
              href: "#",
              class: "text-dark fw-bold text-hover-primary mb-1 fs-6"
            }, "Popular Authors"),
            /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-semibold d-block" }, "Most Successful")
          ]),
          /*#__PURE__*/_createElementVNode("td", { class: "text-end text-muted fw-bold" }, "Python, MySQL"),
          /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, [
            /*#__PURE__*/_createElementVNode("span", { class: "badge badge-light-warning" }, "In Progress")
          ]),
          /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, [
            /*#__PURE__*/_createElementVNode("a", {
              href: "#",
              class: "btn btn-sm btn-icon btn-bg-light btn-active-color-primary"
            }, [
              /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
                /*#__PURE__*/_createElementVNode("svg", {
                  width: "24",
                  height: "24",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  /*#__PURE__*/_createElementVNode("rect", {
                    opacity: "0.5",
                    x: "18",
                    y: "13",
                    width: "13",
                    height: "2",
                    rx: "1",
                    transform: "rotate(-180 18 13)",
                    fill: "currentColor"
                  }),
                  /*#__PURE__*/_createElementVNode("path", {
                    d: "M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z",
                    fill: "currentColor"
                  })
                ])
              ])
            ])
          ])
        ]),
        /*#__PURE__*/_createElementVNode("tr", null, [
          /*#__PURE__*/_createElementVNode("td", null, [
            /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-45px me-2" }, [
              /*#__PURE__*/_createElementVNode("span", { class: "symbol-label" }, [
                /*#__PURE__*/_createElementVNode("img", {
                  src: "/metronic8/demo8/assets/media/svg/brand-logos/bebo.svg",
                  class: "h-50 align-self-center",
                  alt: ""
                })
              ])
            ])
          ]),
          /*#__PURE__*/_createElementVNode("td", null, [
            /*#__PURE__*/_createElementVNode("a", {
              href: "#",
              class: "text-dark fw-bold text-hover-primary mb-1 fs-6"
            }, "Active Customers"),
            /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-semibold d-block" }, "Movie Creator")
          ]),
          /*#__PURE__*/_createElementVNode("td", { class: "text-end text-muted fw-bold" }, "AngularJS, C#"),
          /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, [
            /*#__PURE__*/_createElementVNode("span", { class: "badge badge-light-danger" }, "Rejected")
          ]),
          /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, [
            /*#__PURE__*/_createElementVNode("a", {
              href: "#",
              class: "btn btn-sm btn-icon btn-bg-light btn-active-color-primary"
            }, [
              /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
                /*#__PURE__*/_createElementVNode("svg", {
                  width: "24",
                  height: "24",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  /*#__PURE__*/_createElementVNode("rect", {
                    opacity: "0.5",
                    x: "18",
                    y: "13",
                    width: "13",
                    height: "2",
                    rx: "1",
                    transform: "rotate(-180 18 13)",
                    fill: "currentColor"
                  }),
                  /*#__PURE__*/_createElementVNode("path", {
                    d: "M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z",
                    fill: "currentColor"
                  })
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ])
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  class: "tab-pane fade",
  id: "kt_table_widget_5_tab_3",
  role: "tabpanel"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "table-responsive" }, [
    /*#__PURE__*/_createElementVNode("table", { class: "table table-row-dashed table-row-gray-200 align-middle gs-0 gy-4" }, [
      /*#__PURE__*/_createElementVNode("thead", null, [
        /*#__PURE__*/_createElementVNode("tr", { class: "border-0" }, [
          /*#__PURE__*/_createElementVNode("th", { class: "p-0 w-50px" }),
          /*#__PURE__*/_createElementVNode("th", { class: "p-0 min-w-150px" }),
          /*#__PURE__*/_createElementVNode("th", { class: "p-0 min-w-140px" }),
          /*#__PURE__*/_createElementVNode("th", { class: "p-0 min-w-110px" }),
          /*#__PURE__*/_createElementVNode("th", { class: "p-0 min-w-50px" })
        ])
      ]),
      /*#__PURE__*/_createElementVNode("tbody", null, [
        /*#__PURE__*/_createElementVNode("tr", null, [
          /*#__PURE__*/_createElementVNode("td", null, [
            /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-45px me-2" }, [
              /*#__PURE__*/_createElementVNode("span", { class: "symbol-label" }, [
                /*#__PURE__*/_createElementVNode("img", {
                  src: "/metronic8/demo8/assets/media/svg/brand-logos/kickstarter.svg",
                  class: "h-50 align-self-center",
                  alt: ""
                })
              ])
            ])
          ]),
          /*#__PURE__*/_createElementVNode("td", null, [
            /*#__PURE__*/_createElementVNode("a", {
              href: "#",
              class: "text-dark fw-bold text-hover-primary mb-1 fs-6"
            }, "Bestseller Theme"),
            /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-semibold d-block" }, "Best Customers")
          ]),
          /*#__PURE__*/_createElementVNode("td", { class: "text-end text-muted fw-bold" }, "ReactJS, Ruby"),
          /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, [
            /*#__PURE__*/_createElementVNode("span", { class: "badge badge-light-warning" }, "In Progress")
          ]),
          /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, [
            /*#__PURE__*/_createElementVNode("a", {
              href: "#",
              class: "btn btn-sm btn-icon btn-bg-light btn-active-color-primary"
            }, [
              /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
                /*#__PURE__*/_createElementVNode("svg", {
                  width: "24",
                  height: "24",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  /*#__PURE__*/_createElementVNode("rect", {
                    opacity: "0.5",
                    x: "18",
                    y: "13",
                    width: "13",
                    height: "2",
                    rx: "1",
                    transform: "rotate(-180 18 13)",
                    fill: "currentColor"
                  }),
                  /*#__PURE__*/_createElementVNode("path", {
                    d: "M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z",
                    fill: "currentColor"
                  })
                ])
              ])
            ])
          ])
        ]),
        /*#__PURE__*/_createElementVNode("tr", null, [
          /*#__PURE__*/_createElementVNode("td", null, [
            /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-45px me-2" }, [
              /*#__PURE__*/_createElementVNode("span", { class: "symbol-label" }, [
                /*#__PURE__*/_createElementVNode("img", {
                  src: "/metronic8/demo8/assets/media/svg/brand-logos/bebo.svg",
                  class: "h-50 align-self-center",
                  alt: ""
                })
              ])
            ])
          ]),
          /*#__PURE__*/_createElementVNode("td", null, [
            /*#__PURE__*/_createElementVNode("a", {
              href: "#",
              class: "text-dark fw-bold text-hover-primary mb-1 fs-6"
            }, "Active Customers"),
            /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-semibold d-block" }, "Movie Creator")
          ]),
          /*#__PURE__*/_createElementVNode("td", { class: "text-end text-muted fw-bold" }, "AngularJS, C#"),
          /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, [
            /*#__PURE__*/_createElementVNode("span", { class: "badge badge-light-danger" }, "Rejected")
          ]),
          /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, [
            /*#__PURE__*/_createElementVNode("a", {
              href: "#",
              class: "btn btn-sm btn-icon btn-bg-light btn-active-color-primary"
            }, [
              /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
                /*#__PURE__*/_createElementVNode("svg", {
                  width: "24",
                  height: "24",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  /*#__PURE__*/_createElementVNode("rect", {
                    opacity: "0.5",
                    x: "18",
                    y: "13",
                    width: "13",
                    height: "2",
                    rx: "1",
                    transform: "rotate(-180 18 13)",
                    fill: "currentColor"
                  }),
                  /*#__PURE__*/_createElementVNode("path", {
                    d: "M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z",
                    fill: "currentColor"
                  })
                ])
              ])
            ])
          ])
        ]),
        /*#__PURE__*/_createElementVNode("tr", null, [
          /*#__PURE__*/_createElementVNode("td", null, [
            /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-45px me-2" }, [
              /*#__PURE__*/_createElementVNode("span", { class: "symbol-label" }, [
                /*#__PURE__*/_createElementVNode("img", {
                  src: "/metronic8/demo8/assets/media/svg/brand-logos/vimeo.svg",
                  class: "h-50 align-self-center",
                  alt: ""
                })
              ])
            ])
          ]),
          /*#__PURE__*/_createElementVNode("td", null, [
            /*#__PURE__*/_createElementVNode("a", {
              href: "#",
              class: "text-dark fw-bold text-hover-primary mb-1 fs-6"
            }, "New Users"),
            /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-semibold d-block" }, "Awesome Users")
          ]),
          /*#__PURE__*/_createElementVNode("td", { class: "text-end text-muted fw-bold" }, "Laravel,Metronic"),
          /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, [
            /*#__PURE__*/_createElementVNode("span", { class: "badge badge-light-primary" }, "Success")
          ]),
          /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, [
            /*#__PURE__*/_createElementVNode("a", {
              href: "#",
              class: "btn btn-sm btn-icon btn-bg-light btn-active-color-primary"
            }, [
              /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
                /*#__PURE__*/_createElementVNode("svg", {
                  width: "24",
                  height: "24",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  /*#__PURE__*/_createElementVNode("rect", {
                    opacity: "0.5",
                    x: "18",
                    y: "13",
                    width: "13",
                    height: "2",
                    rx: "1",
                    transform: "rotate(-180 18 13)",
                    fill: "currentColor"
                  }),
                  /*#__PURE__*/_createElementVNode("path", {
                    d: "M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z",
                    fill: "currentColor"
                  })
                ])
              ])
            ])
          ])
        ]),
        /*#__PURE__*/_createElementVNode("tr", null, [
          /*#__PURE__*/_createElementVNode("td", null, [
            /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-45px me-2" }, [
              /*#__PURE__*/_createElementVNode("span", { class: "symbol-label" }, [
                /*#__PURE__*/_createElementVNode("img", {
                  src: "/metronic8/demo8/assets/media/svg/brand-logos/telegram.svg",
                  class: "h-50 align-self-center",
                  alt: ""
                })
              ])
            ])
          ]),
          /*#__PURE__*/_createElementVNode("td", null, [
            /*#__PURE__*/_createElementVNode("a", {
              href: "#",
              class: "text-dark fw-bold text-hover-primary mb-1 fs-6"
            }, "Popular Authors"),
            /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-semibold d-block" }, "Most Successful")
          ]),
          /*#__PURE__*/_createElementVNode("td", { class: "text-end text-muted fw-bold" }, "Python, MySQL"),
          /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, [
            /*#__PURE__*/_createElementVNode("span", { class: "badge badge-light-warning" }, "In Progress")
          ]),
          /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, [
            /*#__PURE__*/_createElementVNode("a", {
              href: "#",
              class: "btn btn-sm btn-icon btn-bg-light btn-active-color-primary"
            }, [
              /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
                /*#__PURE__*/_createElementVNode("svg", {
                  width: "24",
                  height: "24",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  /*#__PURE__*/_createElementVNode("rect", {
                    opacity: "0.5",
                    x: "18",
                    y: "13",
                    width: "13",
                    height: "2",
                    rx: "1",
                    transform: "rotate(-180 18 13)",
                    fill: "currentColor"
                  }),
                  /*#__PURE__*/_createElementVNode("path", {
                    d: "M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z",
                    fill: "currentColor"
                  })
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ])
], -1)
const _hoisted_9 = {
  key: 0,
  class: "overlay-layer rounded bg-dark bg-opacity-5"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1)
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexcharts = _resolveComponent("apexcharts")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card overlay card-xl-stretch mb-5 mb-xl-8", { 'overlay-block': _ctx.isLoading }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.title), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_apexcharts, {
            width: "500",
            height: "350",
            options: _ctx.chartOptions,
            series: _ctx.series
          }, null, 8, ["options", "series"])
        ]),
        _hoisted_7,
        _hoisted_8
      ]),
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
        : _createCommentVNode("", true)
    ])
  ], 2))
}